import { View } from 'foundations-components/components/View';
import { useHasFoldersTab } from 'framework-listing-lib/internal/Folders/hooks/useFolderProps';
import CrmTableEmptyState from 'framework-listing-lib/internal/Table/components/CrmTableEmptyState';
import useTableDimensions from 'framework-listing-lib/internal/Table/hooks/useTableDimensions';
import { TABLE_MARGIN_BOTTOM } from 'framework-listing-lib/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibFrameworkDataTableEmptyState({
  renderEmptyState,
  emptyStateProps
}) {
  const hasFoldersTab = useHasFoldersTab();
  const {
    height,
    refCallback
  } = useTableDimensions({
    heightAffordances: TABLE_MARGIN_BOTTOM,
    maxHeight: 'full-height'
  });
  return /*#__PURE__*/_jsx("div", {
    ref: refCallback,
    children: /*#__PURE__*/_jsx(View, {
      as: "section",
      minBlockSize: hasFoldersTab ? height : undefined,
      children: /*#__PURE__*/_jsx(CrmTableEmptyState, Object.assign({}, emptyStateProps, {
        children: renderEmptyState
      }))
    })
  });
}